import { useEffect } from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Teilnahmebedingungen() {
  useEffect(() => { document.title = "Teilnahmebedingungen – Englputzeder Tippspiel"; }, []);

  return (
    <LegalLayout title="Teilnahmebedingungen">

      <div className="rounded-md border border-border bg-muted/40 p-3 text-xs text-foreground">
        <b>Unabhängigkeitshinweis:</b> Diese Aktion steht in keinerlei Verbindung mit der FIFA oder offiziellen Sponsoren der FIFA Fußball-Weltmeisterschaft 2026. Alle Bezugnahmen auf die Weltmeisterschaft dienen ausschließlich der beschreibenden Einordnung des Tippspiels.
      </div>

      <LegalSection title="1. Veranstalter">
        <p className="text-foreground font-semibold">Englputzeder GmbH</p>
        <p>Furt 44, 4754 Andrichsfurt, Österreich · FN 659267k · UID ATU82555539</p>
        <p>Kontakt: <a href="mailto:anfrage@englputzeder.at" className="underline">anfrage@englputzeder.at</a></p>
      </LegalSection>

      <LegalSection title="2. Geschicklichkeitsspiel — kein Glücksspiel">
        <p>
          Das „Englputzeder Tippspiel" zur FIFA Fußball-Weltmeisterschaft 2026 ist ausdrücklich als <b className="text-foreground">Geschicklichkeitsspiel</b> ausgestaltet und stellt <b className="text-foreground">kein Glücksspiel im Sinne des § 1 Glücksspielgesetz (GSpG)</b> dar.
        </p>
        <p>
          Die Gewinnentscheidung beruht <b>ausschließlich auf den von den Teilnehmer:innen erspielten Punkten</b>, die sich aus der Genauigkeit ihrer Tipps ergeben (Tendenz, Tor-Differenz, exakter Spielstand, Bonus-Tipps mit Wissens- und Prognosecharakter wie z. B. WM-Sieger). Es findet <b>keine Auslosung statt</b> und <b>kein Zufallsmoment</b> beeinflusst die Ermittlung der Gewinner:innen.
        </p>
        <p>
          Für die Teilnahme wird <b>kein Einsatz und kein Entgelt</b> verlangt. Die Teilnahme ist vollständig kostenlos.
        </p>
      </LegalSection>

      <LegalSection title="3. Teilnahmevoraussetzungen">
        <ul className="list-disc pl-5 space-y-1">
          <li>Mindestalter 18 Jahre</li>
          <li>Wohnsitz in Österreich oder Deutschland</li>
          <li>Vollständige und wahrheitsgemäße Registrierung mit gültiger E-Mail-Adresse</li>
          <li>Pro Person nur ein Account; Mehrfach-Accounts führen zum Ausschluss</li>
          <li>Für die Teilnahme an der Gruppen-Wertung muss die Tippgruppe einem <b className="text-foreground">eingetragenen Verein bzw. einer vergleichbaren Körperschaft</b> zuordenbar sein, der/die eine Sponsoring-Rechnung empfangen kann</li>
          <li>Mitarbeiter:innen der Englputzeder GmbH sowie deren Angehörige sind von der Gewinnausschüttung ausgeschlossen</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Preise">
        <p className="text-foreground font-semibold">Gruppen-Sponsoring (Hauptpreise):</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>1. Platz: <b className="text-foreground">€ 3.000</b> Sponsoring</li>
          <li>2. Platz: <b className="text-foreground">€ 1.500</b> Sponsoring</li>
          <li>3. Platz: <b className="text-foreground">€ 500</b> Sponsoring</li>
        </ul>
        <p>
          Die Gruppen-Wertung ergibt sich aus der Summe aller von den Mitgliedern erspielten Punkte.
        </p>
        <p>
          Die Auszahlung des Gruppen-Sponsorings erfolgt <b className="text-foreground">ausschließlich an einen eingetragenen Verein, eine juristische Person oder eine vergleichbar organisierte Körperschaft</b> (z. B. ZVR-eingetragener Verein, Mannschaft eines Vereins, gemeinnützige Organisation), an die die Englputzeder GmbH eine <b className="text-foreground">ordnungsgemäße Sponsoring-Rechnung</b> ausstellen kann. Die Tippgruppe muss bei Gewinn entsprechende Nachweise (z. B. ZVR-Auszug, UID/Steuernummer, Vereinsdaten) vorlegen. Kann kein gültiger Empfänger benannt werden, verfällt der Anspruch und kann an die nächstplatzierte Gruppe vergeben werden.
        </p>

        <p className="text-foreground font-semibold mt-3">Anmelde-Bonus (für jede:n Teilnehmer:in):</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>1× gratis Englputzeder WM-Trikot — <b>streng limitiert, solange der Vorrat reicht</b></li>
          <li>1× € 50 Gutschein für englputzeder.at, Mindestbestellwert € 1.000, einlösbar bis 31.12.2026</li>
        </ul>
        <p>Eine Barablöse oder Tausch der Preise ist nicht möglich.</p>
      </LegalSection>

      <LegalSection title="5. Gewinnermittlung & Benachrichtigung">
        <p>Die Endwertung erfolgt nach dem Finalspiel der FIFA WM 2026. Maßgeblich ist der Punktestand der Tippgruppen zum Zeitpunkt des Abpfiffs des Finales.</p>
        <p>Die Gewinner:innen werden innerhalb von 14 Tagen per E-Mail an die im Account hinterlegte Adresse verständigt. Meldet sich ein:e Gewinner:in nicht innerhalb von 30 Tagen, verfällt der Anspruch und kann an den/die nächstplatzierte:n vergeben werden.</p>
      </LegalSection>

      <LegalSection title="6. Ausschluss & vorzeitige Beendigung">
        <p>Bei Manipulation, Mehrfach-Accounts, technischer Ausnutzung von Fehlern oder Verstößen gegen diese Bedingungen behält sich die Englputzeder GmbH den Ausschluss vom Tippspiel und die Aberkennung von Preisen vor.</p>
        <p>Die Englputzeder GmbH ist berechtigt, das Tippspiel bei Vorliegen wichtiger Gründe (höhere Gewalt, technische Probleme, Manipulationsverdacht) abzubrechen oder zu modifizieren, ohne dass den Teilnehmer:innen daraus Ansprüche erwachsen.</p>
      </LegalSection>

      <LegalSection title="7. Datenschutz">
        <p>Es gilt unsere <a href="/datenschutz" className="underline">Datenschutzerklärung</a>. Mit der Teilnahme stimmst du zu, dass dein Benutzername und dein Punktestand in Ranglisten innerhalb der App sichtbar sind.</p>
      </LegalSection>

      <LegalSection title="8. Schlussbestimmungen">
        <p>Der Rechtsweg ist ausgeschlossen. Es gilt österreichisches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist — soweit gesetzlich zulässig — Ried im Innkreis.</p>
        <p>Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
      </LegalSection>
    </LegalLayout>
  );
}
